import LogoSection from './LogoSection';

export default LogoSection;
